/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApprovalReport } from '../../models/approval-report';

export interface GetApprovalReport$Params {
  workCenterId: number;
  approvalReportDate: string;
}

export function getApprovalReport(http: HttpClient, rootUrl: string, params: GetApprovalReport$Params, context?: HttpContext): Observable<StrictHttpResponse<ApprovalReport>> {
  const rb = new RequestBuilder(rootUrl, getApprovalReport.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.path('approvalReportDate', params.approvalReportDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApprovalReport>;
    })
  );
}

getApprovalReport.PATH = '/api/v1/workCenter/{workCenterId}/approvals/{approvalReportDate}';
